export default "__VITE_ASSET__94e35ad9__"